import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MyConfigOrganization } from '../../../../models/myConfig';
import { BackOffice24StatesService } from '../state/back-office24-states.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-parkifly-users',
  standalone: false,
  templateUrl: './parkifly-users.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './parkifly-users.component.css'
})
export class ParkiflyUsersComponent {
  @Input() organization: MyConfigOrganization;
  private orgSubscription: Subscription = new Subscription();

  constructor(
    private backOffice24StatesService: BackOffice24StatesService
  ) { }

  ngOnInit(): void {
    this.orgSubscription = this.backOffice24StatesService.currentOrganization$.subscribe(
      org => this.organization = org
    );
  }

  ngOnDestroy(): void {
    this.orgSubscription.unsubscribe();
  }
}
